import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  // Back button on its own line, then the large title below it (the back
  // control is a standalone rounded-square, not inline with the title).
  // Horizontal insets are owned by the surrounding PublicFlowShell, so this
  // only spaces the back button above the title.
  container: {
    gap: theme.spacing[5],
  },
  // Keep the chip(s) hugging their content (so the filled square doesn't
  // stretch) and left-aligned above the title — back and close never render
  // together in practice, but the row supports both defensively.
  controlsRow: {
    flexDirection: 'row',
    gap: theme.spacing[3],
    alignSelf: 'flex-start',
  },
  // Close-only variant (entries list): title and close button share one row,
  // per Figma — not the back-button layout's stacked chip-then-title.
  closeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[5],
  },
  closeTitle: {
    flex: 1,
    minWidth: 0,
  },
});
